module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-ortho-braces"
  }, [_vm._l((_vm.props), function(section, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-ortho-braces__section"
    }, [_c('div', {
      staticClass: "custom-ortho-braces__container"
    }, [_c('div', {
      staticClass: "custom-ortho-braces__col",
      class: {
        'custom-ortho-braces__col--right': section.right
      }
    }, [_c('div', {
      staticClass: "custom-ortho-braces__img-container"
    }, [_c('img', {
      staticClass: "custom-ortho-braces__img",
      attrs: {
        "src": section.img
      }
    })])]), _c('div', {
      staticClass: "custom-ortho-braces__col",
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })])])
  }), _c('Icon', {
    staticClass: "custom-ortho-braces__footer-divider",
    attrs: {
      "name": "patient-top-blue"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b9a51e4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-ortho-braces/custom-ortho-braces.pug
// module id = 704
// module chunks = 1